// extracted by mini-css-extract-plugin
export default {"PageHeader":"PageHeader_PageHeader__PUQY8","arrowLink":"PageHeader_arrowLink__WDLYP","arrowButton":"PageHeader_arrowButton__Xrba-"};